import { connect } from 'react-redux';
import { openModal, sendAnalyticsModalView } from 'actionCreators';
import ModalLink from 'components/shared/ModalLink';

const mapDispatchToProps = (dispatch) => ({
  clickHandler: () => {
    dispatch(sendAnalyticsModalView('release-notes'));
    return dispatch(openModal('releaseNotes'));
  },
});

export default connect(null, mapDispatchToProps)(ModalLink);
